import FieldModel from '../../../models/FieldModel';
import { buildDialog, buildSettingsTable, buildSnackbar } from '../../../helpers/factory/global.factory';

const SET_ARROW_ORDENACAO = 'SET_ARROW_ORDENACAO_PESQUISA_CLIENTE';
const SET_COLUMN_ORDENACAO = 'SET_COLUMN_ORDENACAO_PESQUISA_CLIENTE';
const SET_SETTINGS_TABLE = 'SET_SETTINGS_TABLE_PESQUISA_CLIENTE';
const SET_CACHE_REQUEST_FIELDS = 'SET_CACHE_REQUEST_FIELDS_PESQUISA_CLIENTE';
const SET_PAGE = 'SET_PAGE_PESQUISA_CLIENTE';
const SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE_PESQUISA_CLIENTE';
const SET_LOADING = 'SET_LOADING_PESQUISA_CLIENTE';
const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION_PESQUISA_CLIENTE';
const SET_SNACKBAR = 'SET_SNACKBAR_PESQUISA_CLIENTE';
const SET_REQUEST_FIELDS_VALUE = 'SET_REQUEST_FIELDS_VALUE_PESQUISA_CLIENTE';
const SET_ALERT_DIALOG = 'SET_ALERT_DIALOG_PESQUISA_CLIENTE';
const SET_OPTION_DIALOG = 'SET_OPTION_DIALOG_PESQUISA_CLIENTE';
const SET_SHOW_ADVANCED_SEARCH = 'SET_SHOW_ADVANCED_SEARCH_PESQUISA_CLIENTE';
const CLEAR_SEARCH_MODE = 'CLEAR_SEARCH_MODE_PESQUISA_CLIENTE';
const CLEAR_ADVANCED_SEARCH = 'CLEAR_ADVANCED_SEARCH_PESQUISA_CLIENTE';
const CLEAR = 'CLEAR_PESQUISA_CLIENTE';
const SET_CPF_CNPJ_SELECTOR = 'SET_CPF_CNPJ_SELECTOR_PESQUISA_CLIENTE';
const SET_OBJECT_FOCUS = 'SET_OBJECT_FOCUS_PESQUISA_CLIENTE';
const SET_REQUEST_FIELDS = 'SET_REQUEST_FIELDS_PESQUISA_CLIENTE';
const ON_OPEN_FOLLOW_UP_MODAL = 'OPEN_FOLLOW_UP_MODAL';
const SET_EMAILS_CLIENTE = 'SET_EMAILS_CLIENTE_PESQUISA_CLIENTE';

function buildRequestFields() {
  return {
    nome: new FieldModel({
      name: 'nome',
    }),
    idCliente: new FieldModel({
      name: 'idCliente',
    }),
    unidadeResponsavel: new FieldModel({
      name: 'unidadeResponsavel',
    }),
    cnpjCpf: new FieldModel({
      name: 'cnpjCpf',
    }),
    cnpjCpfField: new FieldModel({
      name: 'cnpjCpfField',
    }),
    cidade: new FieldModel({
      name: 'cidade',
    }),
    estado: new FieldModel({
      name: 'estado',
    }),
    dataFuInicial: new FieldModel({
      name: 'dataFuInicial',
    }),
    dataFuFinal: new FieldModel({
      name: 'dataFuFinal',
    }),
    idClienteAcompanhamento: new FieldModel({
      name: 'idClienteAcompanhamento',
    }),
  };
}

function buildInitialStates() {
  return {
    requestFields: buildRequestFields(),
    snackbar: buildSnackbar(),
    alertDialog: buildDialog(),
    optionDialog: buildDialog(),
    settingsTable: buildSettingsTable(),
    columnOrdenacao: {
      element: 'nome',
      order: 'ASC',
    },
    arrowOrdenacao: false,
    showAdvancedSearch: false,
    cacheRequestFields: null,
    emailsCliente: [],
    searchMode: false,
    scrollPosition: { x: 0, y: 0 },
    loading: false,
    followUpModal: {
      open: false,
      messageFollowUp: '',
      isOwnerAcompanhamento: false,
      idCliente: '',
      idClienteAcompanhamento: '',
    },
  };
}

function changeCnpjCpfHandler(states, action) {
  const cnpjCpfModel = states.requestFields.cnpjCpf.getNewModel(action.value);
  const cnpjCpfFieldModel = states.requestFields.cnpjCpfField.getClearModel();
  return {
    ...states,
    requestFields: {
      ...states.requestFields,
      cnpjCpf: cnpjCpfModel,
      cnpjCpfField: cnpjCpfFieldModel,
    },
  };
}

function changeRequestFieldsValueHandler(states, actions) {
  const { name, value } = actions;
  const fieldModel = states.requestFields[actions.name].copy();
  return { ...states, requestFields: { ...states.requestFields, [name]: fieldModel.onChange(value) } };
}

function changeAlertDialogValueHandler(states, actions) {
  const alertDialog = { ...states.alertDialog, open: actions.open };
  if (actions.variant || actions.message) {
    alertDialog.variant = actions.variant;
    alertDialog.message = actions.message;
  }
  return { ...states, alertDialog };
}

function changeOptionDialogValueHandler(states, actions) {
  const optionDialog = { ...states.optionDialog, open: actions.open };
  if (actions.variant || actions.message) {
    optionDialog.variant = actions.variant;
  }
  return { ...states, optionDialog };
}

function changeSettingsTableHandler(states, actions) {
  return {
    ...states,
    settingsTable: { ...actions.settingsTable },
  };
}

function setArrowOrdenacaoHandler(states) {
  return {
    ...states,
    arrowOrdenacao: !states.arrowOrdenacao,
  };
}

function setColumnOrdenacaoHandler(states, actions) {
  return {
    ...states,
    columnOrdenacao: actions.columnOrdenacao,
  };
}

function changeCacheRequestFieldsHandler(states) {
  const nome = states.requestFields.nome.getValueNotEmpty();
  const idCliente = states.requestFields.idCliente.getValueNotEmpty();
  const unidadeResponsavel = states.requestFields.unidadeResponsavel.getValueNotEmpty();
  const cnpjCpf = states.requestFields.cnpjCpf.getValueNotEmpty();
  const cnpjCpfField = states.requestFields.cnpjCpfField.getValueNotEmpty();
  const cidade = states.requestFields.cidade.getValueNotEmpty();
  const estado = states.requestFields.estado.getValueNotEmpty();
  const dataFuInicial = states.requestFields.dataFuInicial.getSerializeDate();
  const dataFuFinal = states.requestFields.dataFuFinal.getSerializeDate();

  return {
    ...states,
    cacheRequestFields: {
      nome,
      idCliente,
      unidadeResponsavel,
      cnpjCpf,
      cnpjCpfField,
      cidade,
      estado,
      dataFuInicial,
      dataFuFinal,
    },
    searchMode: true,
  };
}

function changeRequestFieldsHandler(states, actions) {
  return {
    ...states,
    requestFields: actions.requestFields,
  };
}

function changeRequestFieldsFocusHandler(states, actions) {
  const { name } = actions;
  const fieldModel = states.requestFields[actions.name].copy();
  return { ...states, requestFields: { ...states.requestFields, [name]: fieldModel.onFocus() } };
}

function changePageHandler(states, actions) {
  return {
    ...states,
    settingsTable: {
      ...states.settingsTable,
      page: actions.page,
    },
  };
}

function changeRowsPerPageAndPageHandler(states, actions) {
  return {
    ...states,
    settingsTable: {
      ...states.settingsTable,
      rowsPerPage: actions.rowsPerPage,
      page: actions.page,
    },
  };
}

function changeLoadingHandler(states, actions) {
  return {
    ...states,
    loading: actions.loading,
  };
}

function changeScrollPositionHandler(states, actions) {
  return {
    ...states,
    scrollPosition: { x: actions.x, y: actions.y },
  };
}

function changeSnackbarValueHandler(states, actions) {
  const snackbar = { ...states.snackbar, open: actions.open };
  if (actions.variant || actions.message) {
    snackbar.variant = actions.variant;
    snackbar.message = actions.message;
  }
  return { ...states, snackbar };
}

function changeStateShowAdvancedSearchHandler(states, actions) {
  return { ...states, showAdvancedSearch: actions.show };
}

function clearAdvancedSearchHandler(states) {
  const { nome } = states.requestFields;
  return {
    ...states,
    requestFields: {
      ...buildRequestFields(),
      nome,
    },
  };
}

function setEmailsClienteHandler(states, actions) {
  return {
    ...states,
    emailsCliente: actions.emails ? actions.emails : [], // Ensure emails is always an array
  };
}

function clearSearchModeHandler(states) {
  return { ...states, searchMode: false };
}

function clearHandler(states) {
  const snackbar = { ...states.snackbar, open: false };
  return {
    ...buildInitialStates(),
    snackbar,
  };
}

function onOpenFollowUpModalHandler(states, actions) {
  const newFollowUpModal = {
    ...states.followUpModal,
    open: actions.open,
    isOwnerAcompanhamento: actions.isOwnerAcompanhamento,
    idCliente: actions.idCliente,
    idClienteAcompanhamento: actions.idClienteAcompanhamento,
  };

  if (actions.followUpMessage) {
    newFollowUpModal.messageFollowUp = actions.followUpMessage;
  }
  return {
    ...states,
    followUpModal: newFollowUpModal,
  };
}

export const setRequestFieldsAction = requestFields => ({
  type: SET_REQUEST_FIELDS,
  requestFields,
});

export const setFocusObjectAction = name => ({
  type: SET_OBJECT_FOCUS,
  name,
});

export const setCpfCnpjSelectorAction = (name, value) => ({
  type: SET_CPF_CNPJ_SELECTOR,
  value,
});

export const setRequestFieldsValueAction = (name, value) => ({
  type: SET_REQUEST_FIELDS_VALUE,
  name,
  value,
});

export const setAlertDialogValuesAction = (open, variant, message) => ({
  type: SET_ALERT_DIALOG,
  open,
  variant,
  message,
});

export const setOptionDialogValuesAction = (open, variant = 'warning') => ({
  type: SET_OPTION_DIALOG,
  open,
  variant,
});

export const setSettingsTableAction = (content, page, rowsPerPage, totalElements) => ({
  type: SET_SETTINGS_TABLE,
  settingsTable: buildSettingsTable(content, page, rowsPerPage, totalElements),
});

export const setEmailsClienteAction = emails => ({
  type: SET_EMAILS_CLIENTE,
  emails,
});

export const setCacheRequestFieldsAction = () => ({
  type: SET_CACHE_REQUEST_FIELDS,
});

export const setArrowOrdenacaoAction = value => ({
  type: SET_ARROW_ORDENACAO,
  value,
});

export const setColumnOrdenacaoAction = columnOrdenacao => ({
  type: SET_COLUMN_ORDENACAO,
  columnOrdenacao,
});


export const setPageAction = page => ({
  type: SET_PAGE,
  page,
});

export const setRowsPerPageAndPageAction = (rowsPerPage, page) => ({
  type: SET_ROWS_PER_PAGE,
  rowsPerPage,
  page,
});

export const setLoadingAction = loading => ({
  type: SET_LOADING,
  loading,
});

export const setScrollPositionAction = (x, y) => ({
  type: SET_SCROLL_POSITION,
  x,
  y,
});

export const setSnackbarValuesAction = (open, variant, message) => ({
  type: SET_SNACKBAR,
  open,
  variant,
  message,
});

export const setShowAdvancedSearchAction = show => ({
  type: SET_SHOW_ADVANCED_SEARCH,
  show,
});

export const clearSearchModelAction = () => ({
  type: CLEAR_SEARCH_MODE,
});

export const clearAdvancedSearchAction = () => ({
  type: CLEAR_ADVANCED_SEARCH,
});

export const clearPesquisarClienteAction = () => ({
  type: CLEAR,
});

export const onOpenFollowUpModalAction = (open, followUpMessage, isOwnerAcompanhamento, idCliente, idClienteAcompanhamento) => ({
  type: ON_OPEN_FOLLOW_UP_MODAL,
  open,
  followUpMessage,
  isOwnerAcompanhamento,
  idCliente,
  idClienteAcompanhamento,
});

export default (states = buildInitialStates(), actions) => {
  switch (actions.type) {
    case SET_REQUEST_FIELDS_VALUE:
      return changeRequestFieldsValueHandler(states, actions);
    case SET_EMAILS_CLIENTE:
      return setEmailsClienteHandler(states, actions);
    case SET_SETTINGS_TABLE:
      return changeSettingsTableHandler(states, actions);
    case SET_CACHE_REQUEST_FIELDS:
      return changeCacheRequestFieldsHandler(states);
    case SET_ARROW_ORDENACAO:
      return setArrowOrdenacaoHandler(states, actions);
    case SET_COLUMN_ORDENACAO:
      return setColumnOrdenacaoHandler(states, actions);
    case SET_PAGE:
      return changePageHandler(states, actions);
    case SET_ROWS_PER_PAGE:
      return changeRowsPerPageAndPageHandler(states, actions);
    case SET_LOADING:
      return changeLoadingHandler(states, actions);
    case SET_SCROLL_POSITION:
      return changeScrollPositionHandler(states, actions);
    case SET_SNACKBAR:
      return changeSnackbarValueHandler(states, actions);
    case SET_ALERT_DIALOG:
      return changeAlertDialogValueHandler(states, actions);
    case SET_OPTION_DIALOG:
      return changeOptionDialogValueHandler(states, actions);
    case SET_SHOW_ADVANCED_SEARCH:
      return changeStateShowAdvancedSearchHandler(states, actions);
    case CLEAR_SEARCH_MODE:
      return clearSearchModeHandler(states);
    case CLEAR_ADVANCED_SEARCH:
      return clearAdvancedSearchHandler(states);
    case CLEAR:
      return clearHandler(states);
    case SET_CPF_CNPJ_SELECTOR:
      return changeCnpjCpfHandler(states, actions);
    case SET_OBJECT_FOCUS:
      return changeRequestFieldsFocusHandler(states, actions);
    case SET_REQUEST_FIELDS:
      return changeRequestFieldsHandler(states, actions);
    case ON_OPEN_FOLLOW_UP_MODAL:
      return onOpenFollowUpModalHandler(states, actions);
    default:
      return states;
  }
};
